// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","zGreen":"#BFD730","dot":"_35oy"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/components/Input/InputValid/InputValid.scss
// module id = YSZl
// module chunks = 0